import { __extends } from "tslib";
import { CreateSnapshotsRequest, CreateSnapshotsResult } from "../models/models_1";
import { deserializeAws_ec2CreateSnapshotsCommand, serializeAws_ec2CreateSnapshotsCommand } from "../protocols/Aws_ec2";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Creates crash-consistent snapshots of multiple EBS volumes and stores the data in S3.
 *     Volumes are chosen by specifying an instance. Any attached volumes will produce one snapshot
 *     each that is crash-consistent across the instance. Boot volumes can be excluded by changing the
 *     parameters. </p>
 */
var CreateSnapshotsCommand = /** @class */ (function (_super) {
    __extends(CreateSnapshotsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateSnapshotsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateSnapshotsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "EC2Client";
        var commandName = "CreateSnapshotsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateSnapshotsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateSnapshotsResult.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateSnapshotsCommand.prototype.serialize = function (input, context) {
        return serializeAws_ec2CreateSnapshotsCommand(input, context);
    };
    CreateSnapshotsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_ec2CreateSnapshotsCommand(output, context);
    };
    return CreateSnapshotsCommand;
}($Command));
export { CreateSnapshotsCommand };
//# sourceMappingURL=CreateSnapshotsCommand.js.map